import { createFileRoute } from '@tanstack/react-router';
import { StreamDetailPage } from '../../../features/catalog/StreamDetailPage.js';
import { loadCatalog } from '../../../features/catalog/streams.js';

export const Route = createFileRoute('/_app/catalog/$stream')({
  loader: ({ context: { queryClient } }) => loadCatalog(queryClient),
  component: StreamDetailPage,
});
